import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import PositionItemForSpDashboard from '../../../Meeting/AgendaDetails/components/Positions/PositionItemForSpDashboard';
import styles from './positions-dashboard-sp.module.scss';

const PositionsDashboardSP = (props) => {
  const { incumbents, loading, approved_date, platform, is_current } = props;

  const [isShowHierarchy, setIsShowHierarchy] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isShowHierarchy && ref.current && !ref.current.contains(e.target)) {
        setIsShowHierarchy(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isShowHierarchy]);

  return (
    <div className={styles.positions}>
      <div className={styles.positionListWrapper}>
        <div className={styles.positionTitle}>
          {approved_date && platform && is_current === 'false' ? `Previous Incumbent` : `Current Incumbent`} Details
        </div>
        <div style={{ marginBottom: '24px' }}>
          {!isEmpty(incumbents) &&
            incumbents.map((item, index) => (
              <PositionItemForSpDashboard
                key={index}
                data={item}
                isEdit={false}
                handleDeletePosition={() => {}}
                lastItem={false}
                approved_date={approved_date}
                platform={platform}
              />
            ))}
        </div>
      </div>
      {loading && <Skeleton count={1} width={'50%'} height={50} style={{ marginBottom: '10px' }} />}
      {loading && <Skeleton count={1} width={'50%'} height={20} style={{ marginBottom: '10px' }} />}

      <div className={styles.fontMedium}>Description of role(s)/ requirements</div>
      <div className={styles.textArea}>
        <textarea className={styles.textAreaInput} placeholder="" disabled={true} value={incumbents?.[0]?.remark} />
      </div>
    </div>
  );
};

PositionsDashboardSP.propTypes = {
  incumbents: PropTypes.array,
  loading: PropTypes.bool,
};

export default PositionsDashboardSP;
